<template>
    <div class="page-actions">
        <slot></slot>

        <b-button v-for="action in primaryActions"
                  :key="action.key"
                  :variant="action.variant || 'primary'"
                  :to="action.to"
                  :disabled="action.disabled || action.loading"
                  :type="action.type || 'button'"
                  @click="trigger(action)">
            <b-spinner v-if="action.loading" small class="mr-5"></b-spinner>
            <feather-icon v-else-if="action.icon" :icon="action.icon" class="mr-5"></feather-icon>
            {{ action.label }}
        </b-button>

        <slot name="secondary"></slot>

        <b-dropdown v-if="secondaryActions.length"
                    :variant="moreVariant"
                    right
                    no-caret
                    toggle-class="tap-target"
                    class="page-actions__more">
            <template #button-content>
                <feather-icon icon="MoreHorizontalIcon"></feather-icon>
                <span class="sr-only">Flere handlinger</span>
            </template>

            <template v-for="(action, index) in secondaryActions">
                <b-dropdown-divider v-if="action.divider && index > 0" :key="action.key + '-divider'"></b-dropdown-divider>
                <b-dropdown-item :key="action.key"
                                 :to="action.to"
                                 :disabled="action.disabled"
                                 :variant="dropdownVariant(action)"
                                 @click="trigger(action)">
                    <feather-icon v-if="action.icon" :icon="action.icon" class="mr-5"></feather-icon>
                    {{ action.label }}
                </b-dropdown-item>
            </template>
        </b-dropdown>
    </div>
</template>

<script>
    /*
     * Page-level action bar. Used inside <portal to="buttons">.
     *
     *   actions: [{ key, label, icon?, variant?, to?, click?, disabled?, loading?, visible?, secondary?, divider?, type? }]
     *
     * The first `maxPrimary` visible non-secondary actions render as buttons; the rest are
     * collapsed into a "..." dropdown. On phones (< md) only the first primary action stays
     * as a button so the sticky bottom bar never overflows.
     */
    export default {
        props: {
            actions: {
                type: Array,
                default: () => []
            },
            maxPrimary: {
                type: Number,
                default: 2
            },
            moreVariant: {
                type: String,
                default: 'outline-secondary'
            }
        },
        computed: {
            visibleActions() {
                return this.actions.filter(x => x && x.visible !== false)
            },
            limit() {
                return this.isMobile ? Math.min(this.maxPrimary, 1) : this.maxPrimary
            },
            primaryActions() {
                return this.visibleActions.filter(x => !x.secondary).slice(0, this.limit)
            },
            secondaryActions() {
                var overflow = this.visibleActions.filter(x => !x.secondary).slice(this.limit)
                return overflow.concat(this.visibleActions.filter(x => x.secondary))
            }
        },
        methods: {
            trigger(action) {
                if (action.click) {
                    action.click()
                }
                this.$emit('action', action.key)
            },
            dropdownVariant(action) {
                if (action.variant === 'danger' || action.variant === 'outline-danger') {
                    return 'danger'
                }
                return null
            }
        }
    }
</script>
